import axios from 'axios/index'

const namespaced = true

const state = {
  visible: false,
  portals: null,
  packages: null,
  statuses: null,
  definitePackage: null,
  documents: null,
  loading: false,
  pages: null,
  pids: null,
  declineReasons: null
}
const actions = {
  getReportExcelZip (_, data) {
    return new Promise((resolve, reject) => {
      axios.get(`//${data.host}/reports/report_excel_zip/?host=${data.host}&package_id=${data.packageId}`, {responseType: 'blob'})
        .then((response) => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReport4emptycont_new (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `//${data.host}/reports/report4emptycont_new/?host=${data.host}&package_id=${data.packageId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReport4 (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `//${data.host}/reports/report4_new/?host=${data.host}&package_id=${data.packageId}`
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getStatuses ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams(data.queryParams).toString()
      axios({
        method: 'GET',
        url: `/api/private/v5.0/list/package/statuses/${data.portalId}/current/?` + params
      })
        .then(response => {
          commit('setStatuses', response.data)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  getPortalsList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v5.0/portals/'
      })
        .then(response => {
          commit('setPortalsList', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPackagesFromPortal ({ commit }, data) {
    const params = new URLSearchParams(data.queryParams)
    let keysForDel = [];
    params.forEach((value, key) => {
      if (value == '') {
          keysForDel.push(key)
      }
    })
    keysForDel.forEach(key => {
        params.delete(key)
    })
    const url = `/api/private/v5.0/portals/${data.portalId}/packages/?`
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: url + params.toString()
      })
        .then(response => {
          commit('setPackages', response.data)
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  loadPackageDocuments ({ commit }, data) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/portals/${data.portalId}/packages/${data.package}/documents/`
      })
        .then(response => {
          commit('setPackageDocuments', response.data)
          commit('setLoading', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  }
}
const mutations = {
  setLoading (state, value) {
    state.loading = value
  },
  setVisible (state, value) {
    state.visible = value
  },
  setPortalsList (state, data) {
    state.portals = data
  },
  setPackages (state, data) {
    for (let i = 0; i < data.packages.length; i++) {
      data.packages[i].documents = null
      data.packages[i].actions = { visible: false }
      data.packages[i].index = i.toString()
      data.packages[i].waybill = data.packages[i].info[1]
      data.packages[i].vehicle = data.packages[i].info[4]
      data.packages[i].manifest = { id: null, progress: false }
    }
    state.packages = data.packages.filter((p) => {
      return p.status !== 107
    })
    if (data.pages) {
      state.pages = data.pages
    }
    if (data.pids) {
      state.pids = data.pids
    }
  },
  setPackageDocuments (state, data) {
    state.documents = data
  },
  setStatuses (state, data) {
    data = data.map((item) => {
      item.label = item.name
      return item
    })
    state.statuses = data
  },
  setDeclineReasons (state, data) {
    state.declineReasons = data
    localStorage.setItem('decline_reasons', JSON.stringify(data))
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
